/**
 * Role management types for IAM system
 */

export interface Role {
  role_id: number;
  name: string;
  description?: string;
  permissions: Record<string, boolean>;
  is_system_role: boolean;
  created_at: string;
  updated_at: string;
  user_count?: number;
}

export interface RoleCreate {
  name: string;
  description?: string;
  permissions: Record<string, boolean>;
}

export interface RoleUpdate {
  name?: string;
  description?: string;
  permissions?: Record<string, boolean>;
}

// Permission keys
export const PERMISSION_KEYS = {
  USER_MANAGEMENT: 'user_management',
  ALL_FEATURES: 'all_features',
} as const;

// Role badge colors
export const ROLE_COLORS: Record<string, string> = {
  Admin: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  Developers: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  Product: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  'C-Suite': 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300',
};

// Default permissions for new roles
export const DEFAULT_PERMISSIONS: Record<string, boolean> = {
  user_management: false,
  all_features: true,
};

